import { render } from "./RiStepProject.vue?vue&type=template&id=a2e85720"
import script from "./RiStepProject.vue?vue&type=script&lang=js"
export * from "./RiStepProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiStepProject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2e85720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2e85720', __exports__)) {
    api.reload('a2e85720', __exports__)
  }
  
  module.hot.accept("./RiStepProject.vue?vue&type=template&id=a2e85720", () => {
    api.rerender('a2e85720', render)
  })

}


export default __exports__